// removed by extract-text-webpack-plugin
module.exports = {"block":"Cards__block___2B41a"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cards.css
// module id = 106
// module chunks = 0